module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ordernav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        "active": item.isclick
      },
      on: {
        "click": function($event) {
          return _vm.toggleNav(item)
        }
      }
    }, [_vm._v(_vm._s(item.type))])
  }), 0), (_vm.isAll) ? _c('div', {
    staticClass: "order-wrap"
  }, _vm._l((_vm.orderList), function(item, index) {
    return _c('div', {
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "row1"
    }, [_c('div', {
      staticClass: "order-id"
    }, [_vm._v("订单号:" + _vm._s(item.id))]), _c('div', {
      staticClass: "order-time"
    }, [_vm._v(_vm._s(item.time))]), _c('div', {
      staticClass: "order-type"
    }, [_vm._v(_vm._s(item.type))])]), _c('div', {
      staticClass: "row2"
    }, [_c('div', {
      staticClass: "order-place"
    }, [_vm._v(_vm._s(item.place))]), _c('div', {
      staticClass: "order-table"
    }, [_vm._v("   " + _vm._s(item.table) + "号桌")]), _c('div', {
      staticClass: "order-peoplesum"
    }, [_vm._v("   " + _vm._s(item.peoplenum) + "人用餐")])]), _c('div', {
      staticClass: "row3"
    }, [_vm._v("所点菜品详情")]), _vm._l((item.foodList), function(it, i) {
      return _c('div', {
        staticClass: "food-desc"
      }, [_c('div', {
        staticClass: "foodname"
      }, [_vm._v(_vm._s(it.name)), (it.taste && it.taste.length > 0) ? _c('span', [_vm._v("(" + _vm._s(it.taste) + ")")]) : _vm._e()]), _c('div', {
        staticClass: "foodsum"
      }, [_vm._v(_vm._s(it.sum) + "份")]), _c('div', {
        staticClass: "price"
      }, [_vm._v("   ￥" + _vm._s(it.price))])])
    }), _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("总计")]), _c('div', {
      staticClass: "totalsum"
    }, [_vm._v(" " + _vm._s(item.foodList.length) + "份  ")]), _c('div', [_vm._v(_vm._s(_vm._f("format")(item.totalprice)))])]), (item.discount > 0) ? _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("优惠折扣")]), _c('div', [_vm._v("会员等级折扣 " + _vm._s(item.discount) + "折")])]) : _vm._e(), _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("实际支付")]), _c('div', [_vm._v(_vm._s(_vm._f("format")(item.totalprice * (item.discount / 10))) + "元 ")])]), (item.type != "待支付") ? _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("支付方式")]), _c('div', [_vm._v(_vm._s(item.payway) + "支付")])]) : _c('div', {
      staticClass: "pay-btn-wrap"
    }, [_c('div', {
      staticClass: "pay-btn"
    }, [_vm._v("前往支付              ")])])], 2)
  }), 0) : _vm._e(), (!_vm.isAll) ? _c('div', {
    staticClass: "order-wrap"
  }, _vm._l((_vm.itemList), function(item, index) {
    return _c('div', {
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "row1"
    }, [_c('div', {
      staticClass: "order-id"
    }, [_vm._v("订单号:" + _vm._s(item.id))]), _c('div', {
      staticClass: "order-time"
    }, [_vm._v(_vm._s(item.time))]), _c('div', {
      staticClass: "order-type"
    }, [_vm._v(_vm._s(item.type))])]), _c('div', {
      staticClass: "row2"
    }, [_c('div', {
      staticClass: "order-place"
    }, [_vm._v(_vm._s(item.place))]), _c('div', {
      staticClass: "order-table"
    }, [_vm._v("   " + _vm._s(item.table) + "号桌")]), _c('div', {
      staticClass: "order-peoplesum"
    }, [_vm._v("   " + _vm._s(item.peoplenum) + "人用餐")])]), _c('div', {
      staticClass: "row3"
    }, [_vm._v("所点菜品详情")]), _vm._l((item.foodList), function(it, i) {
      return _c('div', {
        staticClass: "food-desc"
      }, [_c('div', {
        staticClass: "foodname"
      }, [_vm._v(_vm._s(it.name)), (it.taste && it.taste.length > 0) ? _c('span', [_vm._v("(" + _vm._s(it.taste) + ")")]) : _vm._e()]), _c('div', {
        staticClass: "foodsum"
      }, [_vm._v(_vm._s(it.sum) + "份")]), _c('div', {
        staticClass: "price"
      }, [_vm._v("   ￥" + _vm._s(it.price))])])
    }), _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("总计")]), _c('div', {
      staticClass: "totalsum"
    }, [_vm._v(" " + _vm._s(item.foodList.length) + "份  ")]), _c('div', [_vm._v(_vm._s(_vm._f("format")(item.totalprice)))])]), (item.discount > 0) ? _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("优惠折扣")]), _c('div', [_vm._v("会员等级折扣 " + _vm._s(item.discount) + "折")])]) : _vm._e(), _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("实际支付")]), _c('div', [_vm._v(_vm._s(_vm._f("format")(item.totalprice * (item.discount / 10))) + "元 ")])]), (item.type != "待支付") ? _c('div', {
      staticClass: "row5"
    }, [_c('div', [_vm._v("支付方式")]), _c('div', [_vm._v(_vm._s(item.payway) + "支付")])]) : _c('div', {
      staticClass: "pay-btn-wrap"
    }, [_c('div', {
      staticClass: "pay-btn"
    }, [_vm._v("前往支付          ")])])], 2)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-158ddeee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order.vue
// module id = 108
// module chunks = 0